let lenisRef = null;

export const setLenis = (l) => { lenisRef = l; };
export const getLenis = () => lenisRef;

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (lenisRef) lenisRef.scrollTo(el, { offset: -70, duration: 1.4, force: true });
  else el.scrollIntoView({ behavior: "smooth", block: "start" });
};

export const lockScroll = (locked) => {
  if (lenisRef) { if (locked) lenisRef.stop(); else lenisRef.start(); }
  document.body.style.overflow = locked ? "hidden" : "";
};
